'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AnalyticsRequestDimensionsMixin = require('./AnalyticsRequestDimensionsMixin');

var _AnalyticsRequestDimensionsMixin2 = _interopRequireDefault(_AnalyticsRequestDimensionsMixin);

var _AnalyticsRequestFiltersMixin = require('./AnalyticsRequestFiltersMixin');

var _AnalyticsRequestFiltersMixin2 = _interopRequireDefault(_AnalyticsRequestFiltersMixin);

var _AnalyticsRequestPropertiesMixin = require('./AnalyticsRequestPropertiesMixin');

var _AnalyticsRequestPropertiesMixin2 = _interopRequireDefault(_AnalyticsRequestPropertiesMixin);

var _AnalyticsRequestBase = require('./AnalyticsRequestBase');

var _AnalyticsRequestBase2 = _interopRequireDefault(_AnalyticsRequestBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @description
 * Class for constructing a request object to use for communicating with the analytics API endpoint.
 *
 * @param {!Object} options Object with analytics request options
 *
 * @memberof module:analytics
 *
 * @extends module:analytics.AnalyticsRequestDimensionsMixin
 * @extends module:analytics.AnalyticsRequestFiltersMixin
 * @extends module:analytics.AnalyticsRequestPropertiesMixin
 * @extends module:analytics.AnalyticsRequestBase
 */
var AnalyticsRequest = function (_AnalyticsRequestDime) {
    _inherits(AnalyticsRequest, _AnalyticsRequestDime);

    function AnalyticsRequest() {
        _classCallCheck(this, AnalyticsRequest);

        return _possibleConstructorReturn(this, (AnalyticsRequest.__proto__ || Object.getPrototypeOf(AnalyticsRequest)).apply(this, arguments));
    }

    return AnalyticsRequest;
}((0, _AnalyticsRequestDimensionsMixin2.default)((0, _AnalyticsRequestFiltersMixin2.default)((0, _AnalyticsRequestPropertiesMixin2.default)(_AnalyticsRequestBase2.default))));

exports.default = AnalyticsRequest;
//# sourceMappingURL=AnalyticsRequest.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/analytics/AnalyticsRequest.js
// module id = 115
// module chunks = 13